// Generated by purs version 0.15.15
import * as Class_MonadLog from "../Class.MonadLog/index.js";
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Monad_Error_Class from "../Control.Monad.Error.Class/index.js";
import * as Control_Monad_Fork_Class from "../Control.Monad.Fork.Class/index.js";
import * as Control_Monad_Rec_Class from "../Control.Monad.Rec.Class/index.js";
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Array_NonEmpty_Internal from "../Data.Array.NonEmpty.Internal/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Function from "../Data.Function/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_FunctorWithIndex from "../Data.FunctorWithIndex/index.js";
import * as Data_Generic_Rep from "../Data.Generic.Rep/index.js";
import * as Data_List_Lazy from "../Data.List.Lazy/index.js";
import * as Data_List_Lazy_Types from "../Data.List.Lazy.Types/index.js";
import * as Data_LoadDirection from "../Data.LoadDirection/index.js";
import * as Data_Map_Internal from "../Data.Map.Internal/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Monoid from "../Data.Monoid/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Semigroup from "../Data.Semigroup/index.js";
import * as Data_Semiring from "../Data.Semiring/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Show_Generic from "../Data.Show.Generic/index.js";
import * as Data_TcpStatsResult from "../Data.TcpStatsResult/index.js";
import * as Data_TransmissionStats from "../Data.TransmissionStats/index.js";
import * as Data_Traversable from "../Data.Traversable/index.js";
import * as Data_Tuple from "../Data.Tuple/index.js";
import * as Data_UUID_Random from "../Data.UUID.Random/index.js";
import * as Data_Unit from "../Data.Unit/index.js";
import * as Fusion_Class_MonadApp from "../Fusion.Class.MonadApp/index.js";
import * as Fusion_Data_Bytes from "../Fusion.Data.Bytes/index.js";
import * as Fusion_Data_Duration from "../Fusion.Data.Duration/index.js";
import * as Fusion_Data_FSError from "../Fusion.Data.FSError/index.js";
import * as Fusion_Data_FSWarning from "../Fusion.Data.FSWarning/index.js";
import * as Fusion_Data_Speed from "../Fusion.Data.Speed/index.js";
import * as Fusion_Data_Timestamp from "../Fusion.Data.Timestamp/index.js";
import * as Fusion_DataProcessing from "../Fusion.DataProcessing/index.js";
import * as Fusion_Generator from "../Fusion.Generator/index.js";
import * as Fusion_LoadOutput from "../Fusion.LoadOutput/index.js";
import * as MST_Data_BasicURL from "../MST.Data.BasicURL/index.js";
import * as MST_Data_EngineCommunication from "../MST.Data.EngineCommunication/index.js";
import * as MST_Data_StreamEvent from "../MST.Data.StreamEvent/index.js";
import * as MST_Data_Units from "../MST.Data.Units/index.js";
import * as URI_Path_Segment from "../URI.Path.Segment/index.js";
import * as WE_Class_AVar from "../WE.Class.AVar/index.js";
import * as WE_Class_MonadRef from "../WE.Class.MonadRef/index.js";
import * as WE_Class_Random from "../WE.Class.Random/index.js";
import * as WE_Class_Time from "../WE.Class.Time/index.js";
var $runtime_lazy = function (name, moduleName, init) {
    var state = 0;
    var val;
    return function (lineNumber) {
        if (state === 2) return val;
        if (state === 1) throw new ReferenceError(name + " was needed before it finished initializing (module " + moduleName + ", line " + lineNumber + ")", moduleName, lineNumber);
        state = 1;
        val = init();
        state = 2;
        return val;
    };
};
var genericShowConstructor = /* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments);
var showRecord = /* #__PURE__ */ Data_Show.showRecord()();
var showRecordFieldsCons = /* #__PURE__ */ Data_Show.showRecordFieldsCons({
    reflectSymbol: function () {
        return "loadedBytes";
    }
});
var showRecordFieldsConsNil = /* #__PURE__ */ Data_Show.showRecordFieldsConsNil({
    reflectSymbol: function () {
        return "timestamp";
    }
})(Fusion_Data_Timestamp.showTimestamp);
var showRecordFieldsCons1 = /* #__PURE__ */ Data_Show.showRecordFieldsCons({
    reflectSymbol: function () {
        return "speed";
    }
})(showRecordFieldsConsNil)(Fusion_Data_Speed.showSpeed);
var genericShowConstructor1 = /* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ showRecord(showRecordFieldsCons1)));
var bytesIsSymbol = {
    reflectSymbol: function () {
        return "bytes";
    }
};
var genericShowConstructor2 = /* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ showRecord(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
    reflectSymbol: function () {
        return "kernelName";
    }
})(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
    reflectSymbol: function () {
        return "kernelVersion";
    }
})(/* #__PURE__ */ Data_Show.showRecordFieldsConsNil({
    reflectSymbol: function () {
        return "stats";
    }
})(Data_TransmissionStats.showTransmissionStats))(Data_Show.showString))(Data_Show.showString))));
var discard = /* #__PURE__ */ Control_Bind.discard(Control_Bind.discardUnit);
var mempty = /* #__PURE__ */ Data_Monoid.mempty(/* #__PURE__ */ Data_Monoid.monoidRecord()(/* #__PURE__ */ Data_Monoid.monoidRecordCons(bytesIsSymbol)(Fusion_Data_Bytes.monoidBytes)()(Data_Monoid.monoidRecordNil)));
var show = /* #__PURE__ */ Data_Show.show(Fusion_Data_FSError.showFSError);
var show1 = /* #__PURE__ */ Data_Show.show(/* #__PURE__ */ showRecord(/* #__PURE__ */ Data_Show.showRecordFieldsConsNil({
    reflectSymbol: function () {
        return "error";
    }
})(MST_Data_EngineCommunication.showEngineResponseError)));
var eq = /* #__PURE__ */ Data_Eq.eq(MST_Data_BasicURL.eqBasicURL);
var lookup = /* #__PURE__ */ Data_Map_Internal.lookup(MST_Data_Units.ordStreamId);
var notEq = /* #__PURE__ */ Data_Eq.notEq(MST_Data_StreamEvent.eqStreamEventPayload);
var show2 = /* #__PURE__ */ Data_Show.show(/* #__PURE__ */ showRecord(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
    reflectSymbol: function () {
        return "payload";
    }
})(showRecordFieldsConsNil)(MST_Data_StreamEvent.showStreamEventPayload)));
var sequence = /* #__PURE__ */ Data_Traversable.sequence(Data_Traversable.traversableArray);
var map = /* #__PURE__ */ Data_Functor.map(Data_Functor.functorArray);
var mempty1 = /* #__PURE__ */ Data_Monoid.mempty(Fusion_Data_Speed.monoidSpeed);
var mempty2 = /* #__PURE__ */ Data_Monoid.mempty(Fusion_Data_Bytes.monoidBytes);
var fromFoldable = /* #__PURE__ */ Data_Array.fromFoldable(Data_List_Lazy_Types.foldableList);
var fromFoldable1 = /* #__PURE__ */ Data_List_Lazy.fromFoldable(Data_Array_NonEmpty_Internal.foldableNonEmptyArray);
var mapFlipped = /* #__PURE__ */ Data_Functor.mapFlipped(Data_Functor.functorArray);
var map1 = /* #__PURE__ */ Data_Functor.map(Data_Maybe.functorMaybe);
var updateAtIndices = /* #__PURE__ */ Data_Array.updateAtIndices(Data_Foldable.foldableArray);
var fold = /* #__PURE__ */ Data_Array.fold(Fusion_Data_Speed.monoidSpeed);
var max = /* #__PURE__ */ Data_Ord.max(Fusion_Data_Timestamp.ordTimestamp);
var mempty3 = /* #__PURE__ */ Data_Monoid.mempty(Fusion_Data_Duration.monoidDuration);
var append1 = /* #__PURE__ */ Data_Semigroup.append(Fusion_Data_Bytes.semigroupBytes);
var add = /* #__PURE__ */ Data_Semiring.add(Data_Semiring.semiringInt);
var Completed = /* #__PURE__ */ (function () {
    function Completed() {

    };
    Completed.value = new Completed();
    return Completed;
})();
var Aborted = /* #__PURE__ */ (function () {
    function Aborted() {

    };
    Aborted.value = new Aborted();
    return Aborted;
})();
var Failed = /* #__PURE__ */ (function () {
    function Failed(value0) {
        this.value0 = value0;
    };
    Failed.create = function (value0) {
        return new Failed(value0);
    };
    return Failed;
})();
var SLOCurrent = /* #__PURE__ */ (function () {
    function SLOCurrent(value0) {
        this.value0 = value0;
    };
    SLOCurrent.create = function (value0) {
        return new SLOCurrent(value0);
    };
    return SLOCurrent;
})();
var SLOIntermediate = /* #__PURE__ */ (function () {
    function SLOIntermediate(value0) {
        this.value0 = value0;
    };
    SLOIntermediate.create = function (value0) {
        return new SLOIntermediate(value0);
    };
    return SLOIntermediate;
})();
var SLOServerSideLoadedBytes = /* #__PURE__ */ (function () {
    function SLOServerSideLoadedBytes(value0) {
        this.value0 = value0;
    };
    SLOServerSideLoadedBytes.create = function (value0) {
        return new SLOServerSideLoadedBytes(value0);
    };
    return SLOServerSideLoadedBytes;
})();
var SLOServerSideIntermediate = /* #__PURE__ */ (function () {
    function SLOServerSideIntermediate(value0) {
        this.value0 = value0;
    };
    SLOServerSideIntermediate.create = function (value0) {
        return new SLOServerSideIntermediate(value0);
    };
    return SLOServerSideIntermediate;
})();
var SLOIntermediateStatsPassive = /* #__PURE__ */ (function () {
    function SLOIntermediateStatsPassive(value0) {
        this.value0 = value0;
    };
    SLOIntermediateStatsPassive.create = function (value0) {
        return new SLOIntermediateStatsPassive(value0);
    };
    return SLOIntermediateStatsPassive;
})();
var SLOIntermediateStatsActive = /* #__PURE__ */ (function () {
    function SLOIntermediateStatsActive(value0) {
        this.value0 = value0;
    };
    SLOIntermediateStatsActive.create = function (value0) {
        return new SLOIntermediateStatsActive(value0);
    };
    return SLOIntermediateStatsActive;
})();
var SLOFinished = /* #__PURE__ */ (function () {
    function SLOFinished(value0) {
        this.value0 = value0;
    };
    SLOFinished.create = function (value0) {
        return new SLOFinished(value0);
    };
    return SLOFinished;
})();
var isFinalStreamLoadOutput = {
    isFinal: function (v) {
        if (v instanceof SLOCurrent) {
            return false;
        };
        if (v instanceof SLOIntermediate) {
            return false;
        };
        if (v instanceof SLOIntermediateStatsPassive) {
            return false;
        };
        if (v instanceof SLOIntermediateStatsActive) {
            return false;
        };
        if (v instanceof SLOFinished) {
            return true;
        };
        if (v instanceof SLOServerSideLoadedBytes) {
            return false;
        };
        if (v instanceof SLOServerSideIntermediate) {
            return false;
        };
        throw new Error("Failed pattern match at Fusion.LoadIntermediate (line 706, column 13 - line 713, column 41): " + [ v.constructor.name ]);
    }
};
var genericStreamLoadOutput_ = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return new SLOCurrent(x.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
            return new SLOIntermediate(x.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inl)) {
            return new SLOServerSideLoadedBytes(x.value0.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0 instanceof Data_Generic_Rep.Inl))) {
            return new SLOServerSideIntermediate(x.value0.value0.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))) {
            return new SLOIntermediateStatsPassive(x.value0.value0.value0.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl))))) {
            return new SLOIntermediateStatsActive(x.value0.value0.value0.value0.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr))))) {
            return new SLOFinished(x.value0.value0.value0.value0.value0.value0);
        };
        throw new Error("Failed pattern match at Fusion.LoadIntermediate (line 697, column 1 - line 697, column 43): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof SLOCurrent) {
            return new Data_Generic_Rep.Inl(x.value0);
        };
        if (x instanceof SLOIntermediate) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0));
        };
        if (x instanceof SLOServerSideLoadedBytes) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0)));
        };
        if (x instanceof SLOServerSideIntermediate) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0))));
        };
        if (x instanceof SLOIntermediateStatsPassive) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0)))));
        };
        if (x instanceof SLOIntermediateStatsActive) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0))))));
        };
        if (x instanceof SLOFinished) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(x.value0))))));
        };
        throw new Error("Failed pattern match at Fusion.LoadIntermediate (line 697, column 1 - line 697, column 43): " + [ x.constructor.name ]);
    }
};
var genericStreamCompletionMa = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return Completed.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
            return Aborted.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inr) {
            return new Failed(x.value0.value0);
        };
        throw new Error("Failed pattern match at Fusion.LoadIntermediate (line 701, column 1 - line 701, column 49): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof Completed) {
            return new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value);
        };
        if (x instanceof Aborted) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value));
        };
        if (x instanceof Failed) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(x.value0));
        };
        throw new Error("Failed pattern match at Fusion.LoadIntermediate (line 701, column 1 - line 701, column 49): " + [ x.constructor.name ]);
    }
};
var showStreamCompletionManne = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericStreamCompletionMa)(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor({
        reflectSymbol: function () {
            return "Completed";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor({
        reflectSymbol: function () {
            return "Aborted";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(Data_Show.showString))({
        reflectSymbol: function () {
            return "Failed";
        }
    }))))
};
var showStreamLoadOutput = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericStreamLoadOutput_)(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ showRecord(/* #__PURE__ */ showRecordFieldsCons(showRecordFieldsCons1)(Fusion_Data_Bytes.showBytes))))({
        reflectSymbol: function () {
            return "SLOCurrent";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor1({
        reflectSymbol: function () {
            return "SLOIntermediate";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ showRecord(/* #__PURE__ */ showRecordFieldsCons(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "startTime";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsConsNil({
        reflectSymbol: function () {
            return "url";
        }
    })(MST_Data_BasicURL.showBasicURL))(Fusion_Data_Timestamp.showTimestamp))(/* #__PURE__ */ Data_Array_NonEmpty_Internal.showNonEmptyArray(/* #__PURE__ */ showRecord(/* #__PURE__ */ Data_Show.showRecordFieldsCons(bytesIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsConsNil({
        reflectSymbol: function () {
            return "durationSinceStart";
        }
    })(Fusion_Data_Duration.showDuration))(Fusion_Data_Bytes.showBytes)))))))({
        reflectSymbol: function () {
            return "SLOServerSideLoadedBytes";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor1({
        reflectSymbol: function () {
            return "SLOServerSideIntermediate";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor2({
        reflectSymbol: function () {
            return "SLOIntermediateStatsPassive";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor2({
        reflectSymbol: function () {
            return "SLOIntermediateStatsActive";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(showStreamCompletionManne))({
        reflectSymbol: function () {
            return "SLOFinished";
        }
    }))))))))
};
var timeoutLoadedBytes = function (dictMonadApp) {
    var Monad0 = (dictMonadApp.MonadWebsockets5()).Monad0();
    var Bind1 = Monad0.Bind1();
    var bind = Control_Bind.bind(Bind1);
    var MonadAppNE4 = dictMonadApp.MonadAppNE4();
    var ManageAVar3 = MonadAppNE4.ManageAVar3();
    var empty = WE_Class_AVar.empty(ManageAVar3);
    var MonadRec1 = MonadAppNE4.MonadRec1();
    var forever = Control_Monad_Rec_Class.forever(MonadRec1);
    var discard1 = discard(Bind1);
    var MonadTime2 = MonadAppNE4.MonadTime2();
    var delay = WE_Class_Time.delay(MonadTime2);
    var now = WE_Class_Time.now(MonadTime2);
    var put = WE_Class_AVar.put(ManageAVar3);
    var bracket = Control_Monad_Fork_Class.bracket(dictMonadApp.MonadBracket2());
    var Applicative0 = Monad0.Applicative0();
    var pure = Control_Applicative.pure(Applicative0);
    var for_ = Data_Foldable.for_(Applicative0)(Data_Foldable.foldableMaybe);
    var kill_ = Fusion_Generator.kill_(dictMonadApp.MonadKill3());
    var fork = Control_Monad_Fork_Class.fork(MonadAppNE4.MonadFork0());
    var tailRecM = Control_Monad_Rec_Class.tailRecM(MonadRec1);
    var take = WE_Class_AVar.take(ManageAVar3);
    return function (timeout) {
        return function (inputStreamer) {
            return bind(empty)(function (av) {
                var timeoutHandler = forever(discard1(delay(timeout))(function () {
                    return bind(now)(function (timestamp) {
                        return put({
                            payload: new MST_Data_StreamEvent.LoadedBytes(mempty),
                            timestamp: timestamp
                        })(av);
                    });
                }));
                var loop = function (tof) {
                    return bind(bracket(pure(Data_Unit.unit))(function (v) {
                        return function (v1) {
                            return for_(tof)(kill_);
                        };
                    })(function (v) {
                        return Fusion_Generator.next(inputStreamer);
                    }))(function (streamEvent) {
                        return discard1(put(streamEvent)(av))(function () {
                            if (streamEvent.payload instanceof MST_Data_StreamEvent.Start) {
                                return pure(new Control_Monad_Rec_Class.Loop(Data_Maybe.Nothing.value));
                            };
                            if (streamEvent.payload instanceof MST_Data_StreamEvent.ResponseStart) {
                                return bind(fork(timeoutHandler))(function (nTof) {
                                    return pure(new Control_Monad_Rec_Class.Loop(new Data_Maybe.Just(nTof)));
                                });
                            };
                            if (streamEvent.payload instanceof MST_Data_StreamEvent.LoadedBytes) {
                                return bind(fork(timeoutHandler))(function (nTof) {
                                    return pure(new Control_Monad_Rec_Class.Loop(new Data_Maybe.Just(nTof)));
                                });
                            };
                            if (streamEvent.payload instanceof MST_Data_StreamEvent.ResponseEnd) {
                                return pure(new Control_Monad_Rec_Class.Done(Data_Unit.unit));
                            };
                            if (streamEvent.payload instanceof MST_Data_StreamEvent.Fail) {
                                return pure(new Control_Monad_Rec_Class.Done(Data_Unit.unit));
                            };
                            if (streamEvent.payload instanceof MST_Data_StreamEvent.Abort) {
                                return pure(new Control_Monad_Rec_Class.Done(Data_Unit.unit));
                            };
                            if (streamEvent.payload instanceof MST_Data_StreamEvent.TransmissionStats) {
                                return pure(new Control_Monad_Rec_Class.Loop(Data_Maybe.Nothing.value));
                            };
                            throw new Error("Failed pattern match at Fusion.LoadIntermediate (line 576, column 7 - line 592, column 30): " + [ streamEvent.payload.constructor.name ]);
                        });
                    });
                };
                return bind(fork(tailRecM(loop)(Data_Maybe.Nothing.value)))(function (fiber) {
                    return pure({
                        next: take(av),
                        cancel: discard1(Fusion_Generator.cancel(inputStreamer))(function () {
                            return kill_(fiber);
                        })
                    });
                });
            });
        };
    };
};
var mkFetchAndEmitStats = function (dictMonadApp) {
    var Monad0 = (dictMonadApp.MonadWebsockets5()).Monad0();
    var Bind1 = Monad0.Bind1();
    var bind = Control_Bind.bind(Bind1);
    var MonadAppNE4 = dictMonadApp.MonadAppNE4();
    var MonadRef4 = MonadAppNE4.MonadRef4();
    var $$new = WE_Class_MonadRef["new"](MonadRef4);
    var Applicative0 = Monad0.Applicative0();
    var pure = Control_Applicative.pure(Applicative0);
    var for_ = Data_Foldable.for_(Applicative0)(Data_Foldable.foldableMaybe);
    var catchError = Control_Monad_Error_Class.catchError((dictMonadApp.MonadBracket2()).MonadError1());
    var fetchTcpStats = Fusion_Class_MonadApp.fetchTcpStats(MonadAppNE4.MonadFetch6());
    var discard1 = discard(Bind1);
    var log = Class_MonadLog.log(MonadAppNE4.MonadLog8());
    var read = WE_Class_MonadRef.read(MonadRef4);
    var put = WE_Class_MonadRef.put(MonadRef4);
    return function (urls) {
        return function (emitLoadOutput) {
            return bind($$new(Data_Maybe.Nothing.value))(function (prevStatRef) {
                return pure(for_(urls.stats)(function (url) {
                    return bind(catchError(bind(fetchTcpStats(url))(function (s) {
                        return pure(new Data_Maybe.Just(s));
                    }))(function (err) {
                        return discard1(log("Warning: " + show(err)))(function () {
                            return pure(Data_Maybe.Nothing.value);
                        });
                    }))(function (v) {
                        return for_(v)(function (stats) {
                            return bind(read(prevStatRef))(function (mPrevStats) {
                                return discard1(put(prevStatRef)(new Data_Maybe.Just(stats.latestStats)))(function () {
                                    var prevStats = Data_Maybe.fromMaybe(stats.startStats)(mPrevStats);
                                    var deltaStats = Data_TransmissionStats.subtract(stats.latestStats)(prevStats);
                                    var passiveInfo = {
                                        stats: deltaStats,
                                        kernelName: stats.kernelName,
                                        kernelVersion: stats.kernelVersion
                                    };
                                    return emitLoadOutput(new SLOIntermediateStatsPassive(passiveInfo));
                                });
                            });
                        });
                    });
                }));
            });
        };
    };
};
var mkFetchAndEmitLoadProgress = function (dictMonadApp) {
    var Monad0 = (dictMonadApp.MonadWebsockets5()).Monad0();
    var Bind1 = Monad0.Bind1();
    var bind = Control_Bind.bind(Bind1);
    var MonadAppNE4 = dictMonadApp.MonadAppNE4();
    var MonadRef4 = MonadAppNE4.MonadRef4();
    var $$new = WE_Class_MonadRef["new"](MonadRef4);
    var Applicative0 = Monad0.Applicative0();
    var pure = Control_Applicative.pure(Applicative0);
    var for_ = Data_Foldable.for_(Applicative0)(Data_Foldable.foldableMaybe);
    var read = WE_Class_MonadRef.read(MonadRef4);
    var fetchUploadProgress = Fusion_Class_MonadApp.fetchUploadProgress(MonadAppNE4.MonadFetch6());
    var discard1 = discard(Bind1);
    var put = WE_Class_MonadRef.put(MonadRef4);
    return function (urls) {
        return function (coalesceInterval) {
            return function (emitLoadOutput) {
                return bind($$new(Data_Maybe.Nothing.value))(function (prevLoadedBytesDurRef) {
                    return pure(for_(urls.progress)(function (url) {
                        return bind(read(prevLoadedBytesDurRef))(function (prevLoadedBytesDur) {
                            return bind(fetchUploadProgress(url)({
                                from: prevLoadedBytesDur,
                                to: Data_Maybe.Nothing.value
                            }))(function (v) {
                                return discard1(put(prevLoadedBytesDurRef)(new Data_Maybe.Just(v.lastDurationSec)))(function () {
                                    return emitLoadOutput(new SLOServerSideLoadedBytes({
                                        loadedBytes: v.loadedBytes,
                                        url: urls.load,
                                        startTime: v.startTime
                                    }));
                                });
                            });
                        });
                    }));
                });
            };
        };
    };
};
var engineStreamer = function (dictMonadApp) {
    var MonadAppNE4 = dictMonadApp.MonadAppNE4();
    var MonadKill3 = dictMonadApp.MonadKill3();
    var MonadBracket2 = dictMonadApp.MonadBracket2();
    var form2toForm1 = Fusion_Generator.form2toForm1(MonadAppNE4.ManageAVar3())(MonadAppNE4.MonadFork0())(MonadKill3)(MonadBracket2.MonadError1());
    var Monad0 = (dictMonadApp.MonadWebsockets5()).Monad0();
    var Bind1 = Monad0.Bind1();
    var discard1 = discard(Bind1);
    var throwError = Control_Monad_Error_Class.throwError(MonadKill3.MonadThrow1());
    var Applicative0 = Monad0.Applicative0();
    var pure = Control_Applicative.pure(Applicative0);
    var bind = Control_Bind.bind(Bind1);
    var for_ = Data_Foldable.for_(Applicative0)(Data_Foldable.foldableArray);
    var bracket = Control_Monad_Fork_Class.bracket(MonadBracket2);
    return function (engineConnection) {
        return function (loadDirection) {
            return function (url) {
                return form2toForm1(function (emit) {
                    return discard1((function () {
                        if (loadDirection instanceof Data_LoadDirection.DownloadP) {
                            return engineConnection.send(new MST_Data_EngineCommunication.StartDownloadStream({
                                url: url
                            }));
                        };
                        if (loadDirection instanceof Data_LoadDirection.UploadP) {
                            return engineConnection.send(new MST_Data_EngineCommunication.StartUploadStream({
                                url: url,
                                byteCount: loadDirection.value0.byteCount
                            }));
                        };
                        throw new Error("Failed pattern match at Fusion.LoadIntermediate (line 423, column 3 - line 432, column 10): " + [ loadDirection.constructor.name ]);
                    })())(function () {
                        var streamStarted = function (ece) {
                            var v = new Data_Tuple.Tuple(loadDirection, ece);
                            if (v.value0 instanceof Data_LoadDirection.DownloadP && v.value1 instanceof MST_Data_EngineCommunication.StartedDownloadStream) {
                                return new Data_Maybe.Just({
                                    streamId: v.value1.value0.streamId,
                                    url: v.value1.value0.url
                                });
                            };
                            if (v.value0 instanceof Data_LoadDirection.UploadP && v.value1 instanceof MST_Data_EngineCommunication.StartedUploadStream) {
                                return new Data_Maybe.Just({
                                    streamId: v.value1.value0.streamId,
                                    url: v.value1.value0.url
                                });
                            };
                            return Data_Maybe.Nothing.value;
                        };
                        var getMessage = function (ece) {
                            if (ece instanceof MST_Data_EngineCommunication.Open) {
                                return throwError(Fusion_Data_FSError.mk(Fusion_Data_FSError.Cl56.value)("expecting an open engine connection, but got Open EngineConnectionEvent"));
                            };
                            if (ece instanceof MST_Data_EngineCommunication.Close) {
                                return throwError(Fusion_Data_FSError.mk(Fusion_Data_FSError.Cl57.value)("expecting an open engine connection, but got Close EngineConnectionEvent"));
                            };
                            if (ece instanceof MST_Data_EngineCommunication.ConnectionFailure) {
                                return throwError(Fusion_Data_FSError.mk(Fusion_Data_FSError.EnCn50.value)("Engine connection failure: " + show1(ece.value0)));
                            };
                            if (ece instanceof MST_Data_EngineCommunication.Message) {
                                return pure(ece.value0.message);
                            };
                            throw new Error("Failed pattern match at Fusion.LoadIntermediate (line 451, column 7 - line 455, column 44): " + [ ece.constructor.name ]);
                        };
                        var $lazy_waitForStreamId = $runtime_lazy("waitForStreamId", "Fusion.LoadIntermediate", function () {
                            return bind(engineConnection.recv)(function (ece) {
                                return bind(getMessage(ece))(function (msg) {
                                    var v = streamStarted(msg);
                                    if (v instanceof Data_Maybe.Just && eq(v.value0.url)(url)) {
                                        return pure(v.value0.streamId);
                                    };
                                    return $lazy_waitForStreamId(464);
                                });
                            });
                        });
                        var waitForStreamId = $lazy_waitForStreamId(458);
                        return bind(waitForStreamId)(function (streamId) {
                            var $lazy_loop = $runtime_lazy("loop", "Fusion.LoadIntermediate", function () {
                                return bind(engineConnection.recv)(function (ece) {
                                    return bind(getMessage(ece))(function (msg) {
                                        if (msg instanceof MST_Data_EngineCommunication.NetworkReport) {
                                            var myEvents = Data_Maybe.fromMaybe([  ])(lookup(streamId)(msg.value0.batch));
                                            return discard1(for_(Data_Array.reverse(myEvents))(function (event) {
                                                return emit(event);
                                            }))(function () {
                                                var v = Data_Array.head(myEvents);
                                                if (v instanceof Data_Maybe.Nothing) {
                                                    return $lazy_loop(484);
                                                };
                                                if (v instanceof Data_Maybe.Just) {
                                                    if (v.value0.payload instanceof MST_Data_StreamEvent.ResponseEnd) {
                                                        return pure(Data_Unit.unit);
                                                    };
                                                    if (v.value0.payload instanceof MST_Data_StreamEvent.Fail) {
                                                        return pure(Data_Unit.unit);
                                                    };
                                                    if (v.value0.payload instanceof MST_Data_StreamEvent.Abort) {
                                                        return pure(Data_Unit.unit);
                                                    };
                                                    return $lazy_loop(489);
                                                };
                                                throw new Error("Failed pattern match at Fusion.LoadIntermediate (line 483, column 11 - line 489, column 24): " + [ v.constructor.name ]);
                                            });
                                        };
                                        return $lazy_loop(490);
                                    });
                                });
                            });
                            var loop = $lazy_loop(469);
                            return bracket(pure(Data_Unit.unit))(function (bracketCondition) {
                                return function (v) {
                                    if (bracketCondition instanceof Control_Monad_Fork_Class.Killed) {
                                        return engineConnection.send(new MST_Data_EngineCommunication.StopStream({
                                            streamId: streamId
                                        }));
                                    };
                                    return pure(Data_Unit.unit);
                                };
                            })(function (v) {
                                return loop;
                            });
                        });
                    });
                });
            };
        };
    };
};
var currentAndIntermediateSpeed = function (dictMonadApp) {
    var Monad0 = (dictMonadApp.MonadWebsockets5()).Monad0();
    var Applicative0 = Monad0.Applicative0();
    var for_ = Data_Foldable.for_(Applicative0)(Data_Foldable.foldableMaybe);
    var Bind1 = Monad0.Bind1();
    var bind = Control_Bind.bind(Bind1);
    var update = Fusion_DataProcessing.update((dictMonadApp.MonadBracket2()).MonadError1());
    var discard1 = discard(Bind1);
    var pure = Control_Applicative.pure(Applicative0);
    var when = Control_Applicative.when(Applicative0);
    var throwError = Control_Monad_Error_Class.throwError((dictMonadApp.MonadKill3()).MonadThrow1());
    return function (coalesceInterval) {
        return function (streamer) {
            return function (emit) {
                var emitIntermediate = function (sdp) {
                    return for_(sdp)(function (cs) {
                        return emit(new SLOIntermediate(cs));
                    });
                };
                var loop = function (state) {
                    return bind(Fusion_Generator.next(streamer))(function (event) {
                        if (event.payload instanceof MST_Data_StreamEvent.LoadedBytes) {
                            return bind(update({
                                coalesceInterval: coalesceInterval
                            })({
                                loadedBytes: event.payload.value0.bytes,
                                timestamp: event.timestamp
                            })(state))(function (newState) {
                                var mcs = Fusion_DataProcessing.currentSpeed(newState);
                                return discard1(for_(mcs)(function (v) {
                                    return emit(new SLOCurrent({
                                        speed: v.speed,
                                        timestamp: v.timestamp,
                                        loadedBytes: event.payload.value0.bytes
                                    }));
                                }))(function () {
                                    return discard1(emitIntermediate(Fusion_DataProcessing.intermediateSpeed({
                                        coalesceInterval: coalesceInterval
                                    })(newState)))(function () {
                                        return loop(newState);
                                    });
                                });
                            });
                        };
                        if (event.payload instanceof MST_Data_StreamEvent.TransmissionStats) {
                            var info = {
                                stats: Data_TcpStatsResult.mkTransStats(event.payload.value0.stats),
                                kernelName: event.payload.value0.stats.kernelName,
                                kernelVersion: event.payload.value0.stats.kernelVersion
                            };
                            return discard1(emit(new SLOIntermediateStatsActive(info)))(function () {
                                return loop(state);
                            });
                        };
                        if (event.payload instanceof MST_Data_StreamEvent.ResponseEnd) {
                            return discard1(emitIntermediate(Fusion_DataProcessing.windowSpeed(state)))(function () {
                                return pure(Completed.value);
                            });
                        };
                        if (event.payload instanceof MST_Data_StreamEvent.Abort) {
                            return discard1(emitIntermediate(Fusion_DataProcessing.windowSpeed(state)))(function () {
                                return pure(Aborted.value);
                            });
                        };
                        if (event.payload instanceof MST_Data_StreamEvent.Fail) {
                            return discard1(emitIntermediate(Fusion_DataProcessing.windowSpeed(state)))(function () {
                                return pure(new Failed(event.payload.value0.message));
                            });
                        };
                        return loop(state);
                    });
                };
                return bind(Fusion_Generator.next(streamer))(function (firstEvent) {
                    if (firstEvent.payload instanceof MST_Data_StreamEvent.Abort) {
                        return pure(Aborted.value);
                    };
                    if (firstEvent.payload instanceof MST_Data_StreamEvent.Fail) {
                        return pure(new Failed(firstEvent.payload.value0.message));
                    };
                    return discard1(when(notEq(firstEvent.payload)(MST_Data_StreamEvent.Start.value))(throwError(Fusion_Data_FSError.mk(Fusion_Data_FSError.Cl58.value)("First streamer event must be SE.Start, was: " + show2(firstEvent)))))(function () {
                        return bind(Fusion_Generator.next(streamer))(function (secondEvent) {
                            if (secondEvent.payload instanceof MST_Data_StreamEvent.Abort) {
                                return pure(Aborted.value);
                            };
                            if (secondEvent.payload instanceof MST_Data_StreamEvent.Fail) {
                                return pure(new Failed(secondEvent.payload.value0.message));
                            };
                            return discard1(when(notEq(secondEvent.payload)(MST_Data_StreamEvent.ResponseStart.value))(throwError(Fusion_Data_FSError.mk(Fusion_Data_FSError.Cl59.value)("Second streamer event must be SE.ResponseStart, was: " + show2(secondEvent)))))(function () {
                                return loop(Fusion_DataProcessing.initialNtmStreamModel(secondEvent.timestamp));
                            });
                        });
                    });
                });
            };
        };
    };
};
var streamProcessor = function (dictMonadApp) {
    var Monad0 = (dictMonadApp.MonadWebsockets5()).Monad0();
    var Bind1 = Monad0.Bind1();
    var bind = Control_Bind.bind(Bind1);
    var mkFetchAndEmitLoadProgress1 = mkFetchAndEmitLoadProgress(dictMonadApp);
    var mkFetchAndEmitStats1 = mkFetchAndEmitStats(dictMonadApp);
    var discard1 = discard(Bind1);
    var MonadBracket2 = dictMonadApp.MonadBracket2();
    var catchError = Control_Monad_Error_Class.catchError(MonadBracket2.MonadError1());
    var MonadAppNE4 = dictMonadApp.MonadAppNE4();
    var log = Class_MonadLog.log(MonadAppNE4.MonadLog8());
    var pure = Control_Applicative.pure(Monad0.Applicative0());
    var forever = Control_Monad_Rec_Class.forever(MonadAppNE4.MonadRec1());
    var delay = WE_Class_Time.delay(MonadAppNE4.MonadTime2());
    var bracket = Control_Monad_Fork_Class.bracket(MonadBracket2);
    var timeoutLoadedBytes1 = timeoutLoadedBytes(dictMonadApp);
    var fork = Control_Monad_Fork_Class.fork(MonadAppNE4.MonadFork0());
    var kill_ = Fusion_Generator.kill_(dictMonadApp.MonadKill3());
    var currentAndIntermediateSpeed1 = currentAndIntermediateSpeed(dictMonadApp);
    return function (mkStreamer) {
        return function (v) {
            return function (emitLoadOutput) {
                return bind(mkFetchAndEmitLoadProgress1(v.urls)(v.coalesceInterval)(emitLoadOutput))(function (fetchAndEmitLoadProgress) {
                    return bind(mkFetchAndEmitStats1(v.urls)(emitLoadOutput))(function (fetchAndEmitTcpStats) {
                        var fetchAndEmitAll = discard1(catchError(fetchAndEmitLoadProgress)(function (err) {
                            return log("Warning: " + show(err));
                        }))(function () {
                            return discard1(catchError(fetchAndEmitTcpStats)(function (err) {
                                return log("Warning: " + show(err));
                            }))(function () {
                                return pure(Data_Unit.unit);
                            });
                        });
                        var fetchAllPeriodically = forever(discard1(delay(Fusion_Data_Duration.fromMs(1000.0)))(function () {
                            return fetchAndEmitAll;
                        }));
                        return bind(bracket(bind(mkStreamer(v.urls.load))(function (untimedStreamer) {
                            return bind((function () {
                                if (v.engineType instanceof MST_Data_EngineCommunication.Local) {
                                    return timeoutLoadedBytes1(Fusion_Data_Duration.scale(2)(v.coalesceInterval));
                                };
                                if (v.engineType instanceof MST_Data_EngineCommunication.Remote) {
                                    return pure;
                                };
                                throw new Error("Failed pattern match at Fusion.LoadIntermediate (line 382, column 13 - line 384, column 31): " + [ v.engineType.constructor.name ]);
                            })()(untimedStreamer))(function (streamer) {
                                return bind(fork(catchError(fetchAllPeriodically)(function (e) {
                                    return log(show(e));
                                })))(function (statsFiber) {
                                    return pure(new Data_Tuple.Tuple(streamer, statsFiber));
                                });
                            });
                        }))(function (bracketCondition) {
                            return function (v1) {
                                return discard1(kill_(v1.value1))(function () {
                                    if (bracketCondition instanceof Control_Monad_Fork_Class.Completed) {
                                        return pure(Data_Unit.unit);
                                    };
                                    if (bracketCondition instanceof Control_Monad_Fork_Class.Failed) {
                                        return emitLoadOutput(new SLOFinished(new Failed(show(bracketCondition.value0))));
                                    };
                                    if (bracketCondition instanceof Control_Monad_Fork_Class.Killed) {
                                        return discard1(Fusion_Generator.cancel(v1.value0))(function () {
                                            return pure(Data_Unit.unit);
                                        });
                                    };
                                    throw new Error("Failed pattern match at Fusion.LoadIntermediate (line 392, column 9 - line 402, column 22): " + [ bracketCondition.constructor.name ]);
                                });
                            };
                        })(function (v1) {
                            return bind(currentAndIntermediateSpeed1(v.coalesceInterval)(v1.value0)(emitLoadOutput))(function (completionManner) {
                                return discard1(kill_(v1.value1))(function () {
                                    return discard1(fetchAndEmitAll)(function () {
                                        return discard1(emitLoadOutput(new SLOFinished(completionManner)))(function () {
                                            return pure(completionManner);
                                        });
                                    });
                                });
                            });
                        }))(function () {
                            return pure(Data_Unit.unit);
                        });
                    });
                });
            };
        };
    };
};
var broadcastEngineConnection = function (dictMonadApp) {
    var Monad0 = (dictMonadApp.MonadWebsockets5()).Monad0();
    var Bind1 = Monad0.Bind1();
    var bind = Control_Bind.bind(Bind1);
    var Applicative0 = Monad0.Applicative0();
    var sequence1 = sequence(Applicative0);
    var MonadAppNE4 = dictMonadApp.MonadAppNE4();
    var ManageAVar3 = MonadAppNE4.ManageAVar3();
    var empty = WE_Class_AVar.empty(ManageAVar3);
    var fork = Control_Monad_Fork_Class.fork(MonadAppNE4.MonadFork0());
    var forever = Control_Monad_Rec_Class.forever(MonadAppNE4.MonadRec1());
    var $$void = Data_Functor["void"]((Bind1.Apply0()).Functor0());
    var put = WE_Class_AVar.put(ManageAVar3);
    var take = WE_Class_AVar.take(ManageAVar3);
    var pure = Control_Applicative.pure(Applicative0);
    var kill_ = Fusion_Generator.kill_(dictMonadApp.MonadKill3());
    return function (count) {
        return function (inputConnection) {
            return bind(sequence1(Data_Array.replicate(count)(empty)))(function (recvAvs) {
                return bind(fork(forever(bind(inputConnection.recv)(function (ece) {
                    var putEce = function (av) {
                        return $$void(fork(put(ece)(av)));
                    };
                    return sequence1(map(putEce)(recvAvs));
                }))))(function (fiber) {
                    var mkConnection = function (av) {
                        return {
                            send: inputConnection.send,
                            recv: take(av),
                            engineType: inputConnection.engineType
                        };
                    };
                    return pure({
                        connections: map(mkConnection)(recvAvs),
                        cancel: kill_(fiber)
                    });
                });
            });
        };
    };
};
var loadIntermediate = function (dictMonadApp) {
    var Monad0 = (dictMonadApp.MonadWebsockets5()).Monad0();
    var Bind1 = Monad0.Bind1();
    var bind = Control_Bind.bind(Bind1);
    var MonadAppNE4 = dictMonadApp.MonadAppNE4();
    var ManageAVar3 = MonadAppNE4.ManageAVar3();
    var empty = WE_Class_AVar.empty(ManageAVar3);
    var put = WE_Class_AVar.put(ManageAVar3);
    var MonadRef4 = MonadAppNE4.MonadRef4();
    var $$new = WE_Class_MonadRef["new"](MonadRef4);
    var broadcastEngineConnection1 = broadcastEngineConnection(dictMonadApp);
    var catchError = Control_Monad_Error_Class.catchError((dictMonadApp.MonadBracket2()).MonadError1());
    var forever = Control_Monad_Rec_Class.forever(MonadAppNE4.MonadRec1());
    var randomUUIDv4 = WE_Class_Random.randomUUIDv4(MonadAppNE4.MonadRandom5());
    var modify = WE_Class_MonadRef.modify(MonadRef4);
    var discard1 = discard(Bind1);
    var Applicative0 = Monad0.Applicative0();
    var pure = Control_Applicative.pure(Applicative0);
    var now = WE_Class_Time.now(MonadAppNE4.MonadTime2());
    var modify_ = WE_Class_MonadRef.modify_(MonadRef4);
    var engineStreamer1 = engineStreamer(dictMonadApp);
    var streamProcessor1 = streamProcessor(dictMonadApp);
    var read = WE_Class_MonadRef.read(MonadRef4);
    var when = Control_Applicative.when(Applicative0);
    var MonadKill3 = dictMonadApp.MonadKill3();
    var throwError = Control_Monad_Error_Class.throwError(MonadKill3.MonadThrow1());
    var fork = Control_Monad_Fork_Class.fork(MonadAppNE4.MonadFork0());
    var parOneOf = Fusion_Class_MonadApp.parOneOf(MonadAppNE4.MonadRaceInParallel7())(Data_Traversable.traversableArray)(Data_FunctorWithIndex.functorWithIndexArray)(Data_Eq.eqInt);
    var take = WE_Class_AVar.take(ManageAVar3);
    var kill_ = Fusion_Generator.kill_(MonadKill3);
    return function (engineConnection) {
        return function (loadDirection) {
            return function (v) {
                return bind(empty)(function (av) {
                    var emit = function (v1) {
                        return put(new Data_Either.Right(v1))(av);
                    };
                    var initialStreamValue = Data_Array.replicate(v.countStreams)({
                        speed: mempty1,
                        timestamp: Fusion_Data_Timestamp.timeIntervalSince1970(Fusion_Data_Duration.fromMs(0.0))
                    });
                    return bind($$new(initialStreamValue))(function (v1) {
                        return bind($$new(initialStreamValue))(function (v2) {
                            return bind($$new(initialStreamValue))(function (v3) {
                                return bind($$new(mempty2))(function (v4) {
                                    return bind($$new(0))(function (v5) {
                                        var streamUrls = fromFoldable(Data_List_Lazy.take(v.countStreams)(Data_List_Lazy.cycle(fromFoldable1(v.urls))));
                                        return bind(broadcastEngineConnection1(v.countStreams)(engineConnection))(function (streamPrivatEngineConnections) {
                                            var indexUrlsConns = Data_Array.mapWithIndex(function (index) {
                                                return function (v6) {
                                                    return {
                                                        index: index,
                                                        url: v6.value0,
                                                        conn: v6.value1
                                                    };
                                                };
                                            })(Data_Array.zip(streamUrls)(streamPrivatEngineConnections.connections));
                                            var streamHandlers = mapFlipped(indexUrlsConns)(function (v6) {
                                                return Data_Function.flip(catchError)(function (err) {
                                                    return put(new Data_Either.Left(err))(av);
                                                })(forever(bind(randomUUIDv4)(function (uuid) {
                                                    var cid = Data_UUID_Random.toString(uuid);
                                                    var urlsWithCid = {
                                                        load: MST_Data_BasicURL.addQueryParameter("connectionId")(new Data_Maybe.Just(cid))(v6.url.load),
                                                        stats: map1(MST_Data_BasicURL.addPathSegment(URI_Path_Segment.segmentFromString(cid)))(v6.url.stats),
                                                        progress: map1(MST_Data_BasicURL.addPathSegment(URI_Path_Segment.segmentFromString(cid)))(v6.url.progress)
                                                    };
                                                    var emitStream = function (v7) {
                                                        if (v7 instanceof SLOCurrent) {
                                                            return bind(modify(v1)(updateAtIndices([ new Data_Tuple.Tuple(v6.index, {
                                                                speed: v7.value0.speed,
                                                                timestamp: v7.value0.timestamp
                                                            }) ])))(function (newSpeeds) {
                                                                var totalSpeed = fold(map(function (v8) {
                                                                    return v8.speed;
                                                                })(newSpeeds));
                                                                var latestTimestamp = Data_Array.foldl(max)(Fusion_Data_Timestamp.timeIntervalSince1970(mempty3))(map(function (v8) {
                                                                    return v8.timestamp;
                                                                })(newSpeeds));
                                                                return bind(modify(v4)(append1(v7.value0.loadedBytes)))(function (bytes) {
                                                                    return emit(new Fusion_LoadOutput.Current({
                                                                        totalSpeed: {
                                                                            speed: totalSpeed,
                                                                            timestamp: latestTimestamp
                                                                        },
                                                                        streamSpeeds: newSpeeds,
                                                                        bytes: bytes
                                                                    }));
                                                                });
                                                            });
                                                        };
                                                        if (v7 instanceof SLOIntermediate) {
                                                            return bind(modify(v2)(updateAtIndices([ new Data_Tuple.Tuple(v6.index, {
                                                                speed: v7.value0.speed,
                                                                timestamp: v7.value0.timestamp
                                                            }) ])))(function (newSpeeds) {
                                                                var totalSpeed = fold(map(function (v8) {
                                                                    return v8.speed;
                                                                })(newSpeeds));
                                                                var latestTimestamp = Data_Array.foldl(max)(Fusion_Data_Timestamp.timeIntervalSince1970(mempty3))(map(function (v8) {
                                                                    return v8.timestamp;
                                                                })(newSpeeds));
                                                                return discard1(emit(new Fusion_LoadOutput.StreamIntermediate({
                                                                    speed: v7.value0.speed,
                                                                    timestamp: v7.value0.timestamp,
                                                                    streamIndex: v6.index
                                                                })))(function () {
                                                                    return emit(new Fusion_LoadOutput.TotalIntermediate({
                                                                        speed: totalSpeed,
                                                                        timestamp: latestTimestamp
                                                                    }));
                                                                });
                                                            });
                                                        };
                                                        if (v7 instanceof SLOIntermediateStatsPassive) {
                                                            var statsInfo = {
                                                                url: urlsWithCid.load,
                                                                stats: v7.value0.stats,
                                                                kernelName: v7.value0.kernelName,
                                                                kernelVersion: v7.value0.kernelVersion
                                                            };
                                                            return emit(new Fusion_LoadOutput.IntermediateStatsPassive(statsInfo));
                                                        };
                                                        if (v7 instanceof SLOIntermediateStatsActive) {
                                                            var statsInfo = {
                                                                url: urlsWithCid.load,
                                                                stats: v7.value0.stats,
                                                                kernelName: v7.value0.kernelName,
                                                                kernelVersion: v7.value0.kernelVersion
                                                            };
                                                            return emit(new Fusion_LoadOutput.IntermediateStatsActive(statsInfo));
                                                        };
                                                        if (v7 instanceof SLOServerSideLoadedBytes) {
                                                            return emit(new Fusion_LoadOutput.ServerSideLoadedBytes({
                                                                startTime: v7.value0.startTime,
                                                                loadedBytes: v7.value0.loadedBytes,
                                                                streamIndex: v6.index,
                                                                url: v7.value0.url
                                                            }));
                                                        };
                                                        if (v7 instanceof SLOServerSideIntermediate) {
                                                            return bind(modify(v3)(updateAtIndices([ new Data_Tuple.Tuple(v6.index, {
                                                                speed: v7.value0.speed,
                                                                timestamp: v7.value0.timestamp
                                                            }) ])))(function (newSpeeds) {
                                                                var totalSpeed = fold(map(function (v8) {
                                                                    return v8.speed;
                                                                })(newSpeeds));
                                                                var latestTimestamp = Data_Array.foldl(max)(Fusion_Data_Timestamp.timeIntervalSince1970(mempty3))(map(function (v8) {
                                                                    return v8.timestamp;
                                                                })(newSpeeds));
                                                                return discard1(emit(new Fusion_LoadOutput.ServerSideStreamIntermediate({
                                                                    speed: v7.value0.speed,
                                                                    timestamp: v7.value0.timestamp,
                                                                    streamIndex: v6.index
                                                                })))(function () {
                                                                    return emit(new Fusion_LoadOutput.ServerSideTotalIntermediate({
                                                                        speed: totalSpeed,
                                                                        timestamp: latestTimestamp
                                                                    }));
                                                                });
                                                            });
                                                        };
                                                        if (v7 instanceof SLOFinished && v7.value0 instanceof Completed) {
                                                            return pure(Data_Unit.unit);
                                                        };
                                                        if (v7 instanceof SLOFinished && v7.value0 instanceof Aborted) {
                                                            return pure(Data_Unit.unit);
                                                        };
                                                        if (v7 instanceof SLOFinished && v7.value0 instanceof Failed) {
                                                            var warning = (function () {
                                                                if (loadDirection instanceof Data_LoadDirection.DownloadP) {
                                                                    return new Fusion_Data_FSWarning.FSWarningDownloadStreamFailed(urlsWithCid.load, v7.value0.value0);
                                                                };
                                                                if (loadDirection instanceof Data_LoadDirection.UploadP) {
                                                                    return new Fusion_Data_FSWarning.FSWarningUploadStreamFailed(urlsWithCid.load, v7.value0.value0);
                                                                };
                                                                throw new Error("Failed pattern match at Fusion.LoadIntermediate (line 262, column 31 - line 264, column 84): " + [ loadDirection.constructor.name ]);
                                                            })();
                                                            return bind(now)(function (timestamp) {
                                                                return discard1(emit(new Fusion_LoadOutput.Warning({
                                                                    warning: warning,
                                                                    timestamp: timestamp,
                                                                    streamIndex: v6.index
                                                                })))(function () {
                                                                    return modify_(v5)(add(1));
                                                                });
                                                            });
                                                        };
                                                        throw new Error("Failed pattern match at Fusion.LoadIntermediate (line 168, column 28 - line 273, column 55): " + [ v7.constructor.name ]);
                                                    };
                                                    var mkStreamer = engineStreamer1(v6.conn)(loadDirection);
                                                    return discard1(streamProcessor1(mkStreamer)({
                                                        urls: urlsWithCid,
                                                        engineType: engineConnection.engineType,
                                                        coalesceInterval: v.coalesceInterval
                                                    })(emitStream))(function () {
                                                        return bind(read(v5))(function (nw) {
                                                            return when(nw >= (v.countStreams + 1 | 0))((function () {
                                                                if (loadDirection instanceof Data_LoadDirection.DownloadP) {
                                                                    return throwError(Fusion_Data_FSError.mk(Fusion_Data_FSError.DnCn51.value)("Too much download streams failed"));
                                                                };
                                                                if (loadDirection instanceof Data_LoadDirection.UploadP) {
                                                                    return throwError(Fusion_Data_FSError.mk(Fusion_Data_FSError.UpCn51.value)("Too much upload streams failed"));
                                                                };
                                                                throw new Error("Failed pattern match at Fusion.LoadIntermediate (line 289, column 15 - line 293, column 90): " + [ loadDirection.constructor.name ]);
                                                            })());
                                                        });
                                                    });
                                                })));
                                            });
                                            return bind(fork(parOneOf(streamHandlers)))(function (streamsFiber) {
                                                return pure({
                                                    next: take(av),
                                                    cancel: discard1(kill_(streamsFiber))(function () {
                                                        return streamPrivatEngineConnections.cancel;
                                                    })
                                                });
                                            });
                                        });
                                    });
                                });
                            });
                        });
                    });
                });
            };
        };
    };
};
export {
    Completed,
    Aborted,
    Failed,
    SLOCurrent,
    SLOIntermediate,
    SLOServerSideLoadedBytes,
    SLOServerSideIntermediate,
    SLOIntermediateStatsPassive,
    SLOIntermediateStatsActive,
    SLOFinished,
    loadIntermediate,
    streamProcessor,
    timeoutLoadedBytes,
    genericStreamLoadOutput_,
    showStreamLoadOutput,
    genericStreamCompletionMa,
    showStreamCompletionManne,
    isFinalStreamLoadOutput
};
//# sourceMappingURL=index.js.map
